
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.483 0H2.517A.512.512 0 002 .507v14.986c0 .424.503.66.841.395l1.055-.83.815.794a.525.525 0 00.717.011l.863-.789.854.788a.525.525 0 00.721-.011l.769-.755.772.755a.525.525 0 00.719.012l.896-.821 1.148.854c.34.253.83.015.83-.404V.508A.512.512 0 0012.483 0zM4.678 7.602h3.628c.286 0 .517.227.517.507s-.231.507-.517.507H4.678a.512.512 0 01-.518-.507c0-.28.232-.507.518-.507zM4.16 5.723c0-.28.232-.507.518-.507h2.236c.286 0 .518.227.518.507s-.232.507-.518.507H4.678a.512.512 0 01-.518-.507zM9.5 11.001H4.678a.512.512 0 01-.518-.506c0-.28.232-.507.518-.507h4.82c.287 0 .518.227.518.507S9.785 11 9.5 11zm.67-7.157H4.679a.512.512 0 01-.518-.507c0-.28.232-.506.518-.506h5.492c.286 0 .517.226.517.506s-.231.507-.517.507z","fill":"#fff"}})])
          )
        }
      }
    